import React from 'react';
import './MessagingChannel.css'; // Import the updated CSS
import DropDown from 'src/SharedComponents/DropDown/DropDown';
import InputBox from 'src/SharedComponents/InputBox/InputBox';
import { memo } from "react";
import DropDownItem from 'src/SharedComponents/DropDown/DropDownItem';
import { Facebook, getChannelTypeIcon, Instagram, Other, WeChat, WhatsApp } from 'src/Utils/Hooks/useGetDistributorInfo/SupportChannalTypes';
import { WeChatIcon, FacebookIcon, InstagramIcon, OtherChannelIcon, WhatsAppIcon } from 'src/SharedComponents/Icons/Icons';

const selectedIconMap: Record<string, React.ReactNode> = {
    [WhatsApp]: <WhatsAppIcon size="large" />,
    [WeChat]: <WeChatIcon size="large" />,
    [Facebook]: <FacebookIcon size="large" />,
    [Instagram]: <InstagramIcon size="large" />,
    [Other]: <OtherChannelIcon size="large" />,
};

const listIconMap: Record<string, React.ReactNode> = {
    [WeChat]: <WeChatIcon />,
    [Facebook]: <FacebookIcon />,
    [Instagram]: <InstagramIcon />,
    [Other]: <OtherChannelIcon />,
};

export interface IMessagingChannal{
    supportChannel?: string,
    supportChannelType?: string
    onChannalChange: (supportChannel:string) => void
    onChannalTypeChange: (supportChannelType:string) => void
}

const MessagingChannel: React.FC<IMessagingChannal> = ({supportChannel, supportChannelType, onChannalChange, onChannalTypeChange}) => {
    const channalIcon = getChannelTypeIcon(supportChannelType)
    const wechat = getChannelTypeIcon(WeChat)
    const facebook = getChannelTypeIcon(Facebook)
    const instagram = getChannelTypeIcon(Instagram)
    const other = getChannelTypeIcon(Other)
    return (
        <div className="messaging-channel-container">
                <DropDown
                    selectedItem={channalIcon}
                    selectedElement={supportChannelType ? selectedIconMap[supportChannelType] : undefined}
                >
                    <div style={{paddingLeft:'18px'}}>
                        <DropDownItem logoSrc={wechat} logoElement={listIconMap[WeChat]} disabled={supportChannelType === WeChat} text={WeChat} OnChange={(item) => onChannalTypeChange(item)} />
                        <DropDownItem logoSrc={facebook} logoElement={listIconMap[Facebook]} disabled={supportChannelType === Facebook} text={Facebook} OnChange={(item) => onChannalTypeChange(item)} />
                        <DropDownItem logoSrc={instagram} logoElement={listIconMap[Instagram]} disabled={supportChannelType === Instagram} text={Instagram} OnChange={(item) => onChannalTypeChange(item)} />
                        <DropDownItem logoSrc={other} logoElement={listIconMap[Other]} disabled={supportChannelType === Other} text={Other} OnChange={(item) => onChannalTypeChange(item)}/>
                    </div>
                </DropDown>
            <div className="description-text">
                <InputBox onChange={(channalText) =>{onChannalChange(channalText)}} value={supportChannel}/>
            </div>
            
        </div>
    );
};

export default memo(MessagingChannel);
